import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
import { aiApi } from '../config';
export function useChat() {
    const api = useApi();
    const state = useAppState();
    function getLastChatMessage(onSuccess = null) {
        api.GET("/Chats/Messages?customerId=" + state.customer.id, (result) => {
            if (onSuccess)
                onSuccess(result);
        }, false);
    }
    function pollForChatResponse(lastMessageId, onSuccess = null) {
        setTimeout(() => {
            getLastChatMessage((lastMessage) => {
                if (lastMessage && lastMessage.length > 0 && lastMessage[0].id != lastMessageId && lastMessage[0].direction == "OUT") {
                    if (onSuccess) {
                        onSuccess(lastMessage[0]);
                    }
                }
                else {
                    pollForChatResponse(lastMessageId, onSuccess);
                }
            });
        }, 5000);
    }
    function sendChatMessage(message, onSuccess = null, allowRetry = true) {
        let lastMessageId = null;
        getLastChatMessage((lastMessage) => {
            if (lastMessage && lastMessage.length > 0) {
                lastMessageId = lastMessage[0].id;
            }
            getHttpInstance().post(getApiConfig().api + "/Chats/ChatRequests?customerID=" + state.customer.id, {
                "body": message
            })
                .then((result) => {
                if (onSuccess) {
                    onSuccess(result.data);
                }
            })
                .catch((result) => {
                console.log(result, 'ERROR CAUGHT');
                if (result.response && result.response.status == 401) {
                    api.refreshLogin(() => {
                        sendChatMessage(message, onSuccess);
                    });
                }
                else if (result.response && result.response.status == 503) {
                    if (allowRetry) {
                        if (onSuccess)
                            onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
                        pollForChatResponse(lastMessageId, onSuccess);
                    }
                    else {
                        if (onSuccess)
                            onSuccess({ body: "Sorry, I can't help you with that right now." });
                    }
                }
                else if (result.code == 'ERR_NETWORK') {
                    if (allowRetry) {
                        if (onSuccess)
                            onSuccess({ body: "I'm still working on that 💭💭 Just a moment!", keepThinking: true });
                        pollForChatResponse(lastMessageId, onSuccess);
                    }
                    else {
                        if (onSuccess)
                            onSuccess({ body: "Sorry, I can't help you with that right now." });
                    }
                }
            });
        });
    }
    function sendSessionlessChatMessage(message, onSuccess = null, onError = null) {
        getHttpInstance().post(getApiConfig().api + "/Chats/ChatRequestsEx", {
            "body": message
        })
            .then((result) => {
            if (onSuccess) {
                onSuccess(result.data);
            }
        })
            .catch((error) => {
            if (!onError)
                throw error;
            onError(error);
        });
    }
    // Streams the reply from the AI service as SSE, calling onChunk with each event's data
    async function streamChatMessage(message, onChunk, allowRetry = true) {
        const res = await fetch(aiApi + "/AI/Chat/Customers/" + state.customer.id + "/Messages/Stream", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": getHttpInstance().defaults.headers.common["Authorization"]
            },
            body: JSON.stringify({ message })
        });
        if (res.status == 401 && allowRetry) {
            return new Promise((resolve, reject) => {
                api.refreshLogin(() => streamChatMessage(message, onChunk, false).then(resolve, reject));
            });
        }
        if (!res.ok)
            throw new Error("Chat stream failed: " + res.status);
        const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
        let buffer = "";
        for (let chunk = await reader.read(); !chunk.done; chunk = await reader.read()) {
            buffer += chunk.value;
            let idx;
            while ((idx = buffer.indexOf("\n\n")) !== -1) {
                const data = buffer.slice(0, idx)
                    .split("\n")
                    .filter(l => l.startsWith("data:"))
                    .map(l => l.slice(l.startsWith("data: ") ? 6 : 5))
                    .join("\n");
                buffer = buffer.slice(idx + 2);
                if (data && data !== "[DONE]")
                    onChunk(data);
            }
        }
    }
    return {
        getLastChatMessage,
        pollForChatResponse,
        sendChatMessage,
        sendSessionlessChatMessage,
        streamChatMessage,
    };
}
